import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import Housing from "./pages/Housing";
import Login from "./pages/Login";
import RegisterForm from "./pages/RegisterForm";
import DetailPage from "./pages/DetailPage";
import CreateListing from "./pages/CreateListing";
import AdminPanel from "./pages/AdminPanel";
import ForgotPassword from "./pages/ForgotPassword";
import Faq from "./pages/Faq";
import Advice from "./pages/Advice";
import MyListings from "./pages/MyListings";
import EditListing from "./pages/EditListing";
import { AuthProvider } from "./context/AuthContext";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className='min-h-screen bg-[#F8F9FA]'>
          <Navbar />
          <div className='pt-16'>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/jobs' element={<Jobs />} />
              <Route path='/housing' element={<Housing />} />
              <Route path='/login' element={<Login />} />
              <Route path='/register' element={<RegisterForm />} />
              <Route path='/detail/:type/:id' element={<DetailPage />} />
              <Route path='/create-listing' element={<CreateListing />} />
              <Route path='/faq' element={<Faq />} />
              <Route path='/advice' element={<Advice />} />
              <Route path='/my-listings' element={<MyListings />} />
              <Route
                path='/edit-listing/:listingId'
                element={<EditListing />}
              />

              <Route path='/forgot-password' element={<ForgotPassword />} />
              <Route
                path='/admin'
                element={
                  <ProtectedAdminRoute>
                    <AdminPanel />
                  </ProtectedAdminRoute>
                }
              />
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
